import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {ImagePreview, Loading} from 'zarm'
import classnames from 'classnames'
import {Observable} from '@utils'
import Player from './Player'
import Image from './Image'
import './index.scss'
import {askSDK} from '@utils/index'

export default class VideoPlayer extends React.Component {
  static defaultProps = {
    // 资源路径
    sourceURL: '',
    sourceList: [],
    // 资源图片
    sourceImage: '',
    // 宽度
    width: 90,
    // 高度
    height: 90,
    // 左右边距
    gutter: [8, 8],
  }

  constructor(props) {
    super(props)
    // 视频播放器容器
    this.videoBoxRef = React.createRef()
    // 判断是否是图片查看器
    this.isOnlyImagePreview = !props.sourceURL
  }

  state = {
    touchActive: false, // 触摸激活
    paused: true, // 是否是暂停
    imageVisible: false, // 弹窗显示图片播放器
  }

  /**
   * 视频播放
   * @param {Object} event 事件对象
   */
  onPlay = (event) => {}

  /**
   * 点击播放touch start
   * @param {Object} event
   */
  onPlayTouchStart = (event) => {
    event.stopPropagation()
    this.setState({touchActive: true})
  }

  /**
   * 点击播放touch end
   * @param {Object} event
   */
  onPlayTouchEnd = (event) => {
    event.stopPropagation()
    const {sourceURL, sourceImage} = this.props

    // 如果是图片查看
    if (this.isOnlyImagePreview) {
      // 防止touchEnd导致图片查看器失效
      setTimeout(() => {
        this.setState(
          {
            imageVisible: true,
            touchActive: false,
            paused: false,
          },
          () => {
            //修改导航栏与背景同色
            askSDK('showNavigationBar', {
              hidden: 1,
              statusbarColor: '#000000',
              showMode: 1,
            })
          }
        )
      }, 10)
      // 在当前tabs检查项中弹出
      // 图片查看器，图片查看器的touchmove会穿透
      // 导致tabs也跟着切换
      // 利用自定义事件发布订阅解决这个问题
      Observable.publish('swipe', true)
    } else {
      // 创建div
      this.div = document.createElement('div')
      document.body.appendChild(this.div)
      // 处理sourceURL
      const source = sourceURL.replace(
        /^(https|http):/,
        window.location.protocol
      )
      // 弹窗播放
      ReactDOM.render(
        <Player
          onCancel={this.onPlayCancel}
          sourceImage={sourceImage}
          sourceURL={source}
        />,
        this.div
      )
      this.setState({touchActive: false, paused: false}, () => {
        //修改导航栏与背景同色
        askSDK('showNavigationBar', {
          hidden: 1,
          statusbarColor: '#000000',
          showMode: 1,
        })
      })
    }
    // 设置样式防止击穿滚动
    setTimeout(() => {
      document.body.style.overflow = 'hidden'
    })
  }

  /**
   * 关闭播放
   */
  onPlayCancel = () => {
    // 在当前tabs检查项中弹出
    // 图片查看器，图片查看器的touchmove会穿透
    // 导致tabs也跟着切换
    // 利用自定义事件发布订阅解决这个问题
    // 此处延迟300毫秒为了防止关闭后明显看见tab切换
    try {
      setTimeout(() => {
        this.setState({paused: true, imageVisible: false}, () => {
          //修改导航栏与背景同色
          askSDK(
            'showNavigationBar',
            {
              hidden: 1,
              statusbarColor: '#00A185',
            },
            (res) => {
              console.log(res, '00000')
            }
          )
          if (this.div) {
            // 移除div
            document.body.removeChild(this.div)
          }
          // 还原body样式
          document.body.style.overflow = 'initial'
          // 图片查看器的dom
          const previewImage =
            document.getElementsByClassName('za-image-preview')
          // 销毁图片查看器的dom，防止页面一直查看，一直存在多个，页面有多余的滚动
          if (previewImage.length > 0) {
            document.body.removeChild(previewImage[0])
          }
        })
      }, 500)
      Loading.hide()

      // 在当前tabs检查项中弹出
      // 图片查看器，图片查看器的touchmove会穿透
      // 导致tabs也跟着切换
      // 利用自定义事件发布订阅解决这个问题
      Observable.publish('swipe', false)
    } catch (error) {
      console.log(error, '错误')
    }
  }

  /**
   * 删除当前视频
   * @param {Object} event
   */
  onDelete = (event) => {
    event.stopPropagation()
    event.preventDefault()
    // 回调方法
    this.props.onDelete(event)
  }

  render() {
    const {
      sourceImage,
      width,
      height,
      showDelete,
      gutter,
      sourceURL,
      sourceList,
    } = this.props
    const {touchActive, paused, imageVisible} = this.state
    // 左右边距
    const [a, b] = gutter

    return (
      <div
        className="video-player"
        style={{
          paddingLeft: b,
          paddingRight: b,
          paddingTop: a,
          paddingBottom: a,
        }}
      >
        <div
          className="video-player-image"
          style={{width, height}}
          // onClick={this.onPlay}
          onTouchStart={this.onPlayTouchStart}
          // onTouchEnd={this.onPlayTouchEnd}
          onClick={this.onPlayTouchEnd}
        >
          {/* 图片显示区域 */}
          <div className="box">
            <Image src={sourceImage} boxWidth={width} boxHeight={height} />
          </div>
          {/* 播放按钮 只有在非图片查看器情况下才显示 */}
          {!this.isOnlyImagePreview && (
            <div className={classnames({action: true, active: touchActive})}>
              <i
                className={classnames({
                  iconfont: true,
                  'icon-playCircle': paused,
                  'icon-zanting': !paused,
                })}
              />
            </div>
          )}
          {/* 删除按钮 */}
          <div
            onClick={this.onDelete}
            onTouchStart={(event) => event.stopPropagation()}
            onTouchEnd={(event) => event.stopPropagation()}
            className={classnames({delete: true, visible: showDelete})}
          >
            <i className="iconfont icon-guanbi" />
          </div>
        </div>
        {/* 图片查看器 */}
        {!sourceURL && imageVisible && (
          <ImagePreview
            visible={imageVisible}
            images={sourceList}
            activeIndex={sourceList.findIndex((item) => item === sourceImage)}
            // images={[
            //   'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg17.3lian.com%2Fd%2Ffile%2F201702%2F27%2F974985feccf5ce7b5f746a4b52924671.jpg&refer=http%3A%2F%2Fimg17.3lian.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1636942194&t=034e958caaf2e81282e51d9bfe75953c',
            //   'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic1.win4000.com%2Fwallpaper%2F2020-10-20%2F5f8e9923041f4.jpg&refer=http%3A%2F%2Fpic1.win4000.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1636942242&t=fc00ee86be5aa6299ccc2354bb9f5b39'
            // ]}
            // activeIndex={0}
            onClose={this.onPlayCancel}
            maxScale={10}
          />
        )}
      </div>
    )
  }
}
